<template>
  <div class="taobao-link-into-box">
    <van-nav-bar
      title="拼多多链接转化"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="link-into-content">
      <textarea v-model="intoContent">
      </textarea>
    </div>
    <van-button type="danger" size="large" @click="linkInto">链接转化</van-button>

    <!-- 搜索结果 -->
    <van-popup v-model="searchShow">
      <div style="padding:20px;">
<van-card
    :price="intoResult.zk_final_price"
    :desc="intoResult.nick"  
    :title="intoResult.title"
    :thumb="intoResult.pict_url"
    />
      </div>
      <van-button type="default" @click="showDetail()">查看商品</van-button>
      <van-button type="danger">领券购买</van-button>
    </van-popup>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        intoContent:'', // 转化内容
        searchShow:false,  //转化结果弹窗
        intoResult:{} , //转化结果
        goodId:'',
      }
    },
    methods:{
//        转化链接
      linkInto(){
        const reg= /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
        const urlList= this.intoContent.match(reg);
        if(urlList === null){
          this.Toast('无效链接，请修改重试');
          return ;
        }
        const url = urlList[0];
         this.Post(
        {
          url: url,
        },
        "/pdd/goodsZsUnitUrlGen",
         res => {
          if (res.states == 1) {
            this.searchShow=true;
            this.goodId=res.data['@attributes'].goodId
            this.intoResult=res.data.results.n_tbk_item
          }
        });
      },
      showDetail(){
          window.localStorage.setItem('goodInfo',JSON.stringify(this.intoResult))
          this.$router.push('/taobao/detail?id='+this.goodId);
      },
    }
  }
</script>

<style lang="less" rel="stylesheet/less" type="text/less" scoped>
  .taobao-link-into-box{
    .link-into-content{
      border: 1px solid #d0d0d0;
      margin: 10px;
      textarea{
        border: none;
        padding: 0;
        margin: 0;
        width: 100%;
        height: 60px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pdd/linkInto.vue